import styled from 'styled-components/macro';

const Header = styled.p`
  padding: 0 3rem;
  font-family: 'SF Pro Display', sans-serif;
  font-size: 1rem;
`;

export default Header;
